import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { PERMISSIONS } from '../constants/permissions';
import EmployeeProfileContainer from './employee-profile/EmployeeProfileContainer';

const EmployeeProfileRoute = () => {
  const { hasPermission } = usePermissions();
  const canViewEmployees = hasPermission(PERMISSIONS.EMPLOYEES.VIEW);

  if (!canViewEmployees) {
    return <EmployeeProfileContainer selfViewOnly requireSelfAccess />;
  }

  return <EmployeeProfileContainer />;
};

export default EmployeeProfileRoute;
